// @flow */

import * as React from 'react';
import Head from 'next/head';
import type { MediaImage } from '@realadvisor/image';

type Props = {|
  media: $ReadOnlyArray<MediaImage>,
|};

// Used in combinantion with Image component, allowing to preload images using link rel="preload"
// improves "Largest Contentful Paint" and gives for images like Hero images better score in lighthouse
export const NextImagePreload = ({ media }: Props): React.Node => (
  <Head>
    {media.map(m => (
      <link
        key={m.srcset}
        rel="prefetch"
        as="image"
        imageSrcSet={m.srcset}
        media={m.media}
      />
    ))}
  </Head>
);
